import React from "react";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  Marketplace,
  PageNotFound,
  Term,
  Policy,
  Authentication,
  ScreenComponents,
  Profile,
  MyPurchases,
  Purchase,
  ProductDetail,
  MyProducts,
  OperationOrders,
  OperationPosition,
  OperationPage,
  OperationPerformance,
  ConfigurationProduct,
  PageMaintenance,
  PurchaseNow,
  OperationResumePosition,
  Predictive,
  PredictiveDetail,
  OperationPredictives,
  AnalystProductPerformance,
} from "../pages";

import Root from "./Root";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { client_selected } from "../client";
import { useAuth } from "../context/auth";

const Router: React.FC = () => {
  const location = useLocation();
  const redirectClient = client_selected.redirect;
  const { isInMaintenance } = useAuth();

  return isInMaintenance ? (
    <Routes>
      <Route
        index
        element={
          <Navigate
            to={"/manutencao-dos-servicos"}
            state={{ from: location }}
            replace
          />
        }
      />
      <Route path="*" element={<Navigate to="/manutencao-dos-servicos" />} />
      <Route path="/manutencao-dos-servicos" element={<PageMaintenance />} />
    </Routes>
  ) : (
    <Routes>
      <Route element={<Root />}>
        <Route
          index
          element={
            <Navigate to={redirectClient} state={{ from: location }} replace />
          }
        />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/marketplace/:subcategory" element={<Marketplace />} />
        <Route path="/marketplace/detalhes/:slug" element={<ProductDetail />} />
        <Route
          path="/marketplace/comprar-agora/:slug"
          element={<PurchaseNow />}
        />
        <Route path="/marketplace/predix" element={<Predictive />} />
        <Route
          path="/marketplace/predix/:predictiveCategory"
          element={<Predictive />}
        />
        <Route
          path="/marketplace/predix/detalhes/:slug"
          element={<PredictiveDetail />}
        />
        {/* <Route path="marketplace/copyorder" element={<CopyOrder />} /> */}
        {/* <Route path="marketplace/copyorder/:slug" element={<ProductDetail />} /> */}
        {/* <Route path="marketplace/smartcopy" element={<SmartCopy />} />
        <Route path="marketplace/smartcopy/:slug" element={<ProductDetail />} /> */}
        <Route
          path="/comprar-servicos"
          element={
            <PrivateRoute>
              <Purchase />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/404" element={<PageNotFound />} />
        <Route path="/politica-de-privacidade" element={<Policy />} />
        <Route path="/termo-de-uso" element={<Term />} />

        <Route
          path="/meu-perfil/configuracoes"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/meu-perfil/financeiro"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/meu-perfil/senha"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          path="/meu-portfolio/minhas-compras"
          element={
            <PrivateRoute>
              <MyPurchases />
            </PrivateRoute>
          }
        />

        <Route
          path="/meu-portfolio/minhas-compras/configuracao-do-servico/:slug"
          element={
            <PrivateRoute>
              <ConfigurationProduct />
            </PrivateRoute>
          }
        />

        <Route
          path="/meu-portfolio/meus-servicos"
          element={
            <PrivateRoute>
              <MyProducts />
            </PrivateRoute>
          }
        />

        <Route path="/operacoes">
          <Route
            path="ordens"
            element={
              <PrivateRoute>
                <OperationPage>
                  <OperationOrders />
                </OperationPage>
              </PrivateRoute>
            }
          />
          <Route
            path="posicoes"
            element={
              <PrivateRoute>
                <OperationPage>
                  <OperationPosition />
                </OperationPage>
              </PrivateRoute>
            }
          />
          <Route
            path="predix"
            element={
              <PrivateRoute>
                <OperationPage>
                  <OperationPredictives />
                </OperationPage>
              </PrivateRoute>
            }
          />
          <Route
            path="resumo-das-posicoes"
            element={
              <PrivateRoute>
                <OperationPage>
                  <OperationResumePosition />
                </OperationPage>
              </PrivateRoute>
            }
          />
          <Route
            path="desempenho"
            element={
              <PrivateRoute>
                <OperationPage>
                  <OperationPerformance />
                </OperationPage>
              </PrivateRoute>
            }
          />
          <Route
            path="performance-produto"
            element={
              <PrivateRoute>
                <OperationPage>
                  <AnalystProductPerformance />
                </OperationPage>
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="/autenticacao"
          element={<Navigate to="/autenticacao/acessar-conta" />}
        />
        <Route
          path="/autenticacao/verficar-email"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="/autenticacao/email-verificado"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="/autenticacao/genial/:token"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="/autenticacao/link-de-ativacao-expirou"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="/autenticacao/acessar-conta"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="/autenticacao/criar-conta"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="/autenticacao/mudar-senha-temporaria"
          element={
            <PublicRoute>
              <Authentication />
            </PublicRoute>
          }
        />
        <Route
          path="manutencao-dos-servicos"
          element={
            <PublicRoute>
              <PageMaintenance />
            </PublicRoute>
          }
        />

        {/* Components */}
        <Route path="c0mp0n&nt$" element={<ScreenComponents />} />
      </Route>
    </Routes>
  );
};

export default Router;
